import {
  faDownload,
  faEye,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import "./Imperiality_table.css";

import Imperiality_view_offcanvas from "../imperiality_view_offcanvas/Imperiality_view_offcanvas";
import Download_offcanvas from "../../../../../../../common/common_offcanvas/download_offcanvas/Download_offcanvas";
import Delete_offcanvas from "../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

import {
  GetAll,
  UploadImperiality,
  Delete,
} from "../../../../../../../features/admin/quality_management/general_requirement/imperiality/Slice";

import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { formatDate } from "../../../../../../../utils/common";
import { FixIDS } from "../../../../../../../utils/fixIDS";

function Imperiality_table() {
  const dispatch = useDispatch();

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(FixIDS.imperiaity.List);

  const haveViewPermission = permissions?.includes(FixIDS.imperiaity.View);
  const haveDownloadPermission = permissions?.includes(
    FixIDS.imperiaity.Download,
  );
  const haveDeletePermission = permissions?.includes(FixIDS.imperiaity.Delete);

  /* ================= STATE ================= */
  const [currentPage, setCurrentPage] = useState(1);
  const [view, setView] = useState(false);
  const [showDownload, setDownload] = useState(false);
  const [showDelete, setDelete] = useState(false);
  const [selectedDownloadId, setSelectedDownloadId] = useState(null);
  const [viewId, setViewId] = useState(null);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  // Upload modal
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const selectedUserIdRef = useRef(null);

  const imperiality = useSelector((state) => state.imperiality);

  /* ================= FETCH LIST ================= */
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: imperiality.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage]);

  /* ================= FILE NAME ================= */
  const getFileName = (path) => {
    if (!path) return "";
    return path.split("/").pop();
  };

  /* ================= OPEN UPLOAD MODAL ================= */
  const openUploadModal = (userId) => {
    selectedUserIdRef.current = userId;
    setShowUploadModal(true);
  };

  /* ================= FILE CHANGE ================= */
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/webp",
    ];

    if (!allowedTypes.includes(file.type)) {
      alert("Only PDF or image files are allowed");
      return;
    }

    setSelectedFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    getValues,
  } = useForm();
  /* ================= CLOSE MODAL ================= */
  const handleCloseUploadModal = () => {
    reset();
    setShowUploadModal(false);
    setSelectedFile(null);
    setPreviewUrl(null);
    selectedUserIdRef.current = null;
  };

  /* ================= PAGINATION ================= */
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* ================= DELETE ================= */
  const handleDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      await dispatch(Delete(selectedDeleteId)).unwrap(); // call redux thunk
      fetchCustomers(currentPage); // refresh the table
      // setDelete(false); // close offcanvas
      setSelectedDeleteId(null); // reset
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };

  const handleDownloadConfirm = () => {
    if (!selectedDownloadId) return;

    const row = imperiality.data.find((item) => item.id === selectedDownloadId);

    if (!row || !row.imperiality) {
      alert("File not found");
      return;
    }

    const imagePath = `${process.env.REACT_APP_IMG_URL}${row.imperiality}`;
    handleDownload(imagePath);
  };

  const handleDownload = async (imagePath) => {
    try {
      console.log("Downloading from ", imagePath);

      const response = await fetch(imagePath);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = imagePath.split("/").pop(); // dynamic filename

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("❌ Image download failed:", err);
      alert("Download failed");
    }
  };

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("imperiality", data?.image[0]);

    try {
      await dispatch(
        UploadImperiality({
          id: selectedUserIdRef.current,
          formData,
        }),
      ).unwrap();

      fetchCustomers(currentPage);
      handleCloseUploadModal();
    } catch (err) {
      console.error("Upload failed", err);
      alert("Upload failed");
    }
  };
  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Date</th>
                  <th>Employee ID</th>
                  <th>Employee Name</th>
                  <th>Designation</th>
                  <th>Attached File</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {imperiality.data.map((row, index) => (
                  <tr key={index}>
                    {/* <td>{index + 1}</td> */}
                    <td>
                      {(imperiality?.current_page - 1) * imperiality?.per_page +
                        index +
                        1}
                    </td>
                    <td>{formatDate(row?.createdAt)}</td>
                    <td>{row.unique_id}</td>
                    <td>{row.name}</td>
                    <td>{row.Role?.name}</td>

                    {/* ===== FILE COLUMN ===== */}
                    <td
                      className={`status attachedFileStatus ${
                        row.imperiality ? "active" : "in_active"
                      }`}
                    >
                      {row.imperiality ? (
                        <span className="file_name">
                          {getFileName(row.imperiality)}
                        </span>
                      ) : (
                        <span
                          className="upload_file"
                          onClick={() => openUploadModal(row.id)}
                        >
                          Upload file
                        </span>
                      )}
                    </td>

                    {/* ===== ACTIONS ===== */}
                    <td>
                      <div className="action_icons">
                        {haveViewPermission && (
                          <FontAwesomeIcon
                            icon={faEye}
                            onClick={() => {
                              setViewId(row.id); // set the ID of the clicked row
                              setView(true); // open the offcanvas
                            }}
                          />
                        )}

                        {row.imperiality && haveDownloadPermission && (
                          <FontAwesomeIcon
                            icon={faDownload}
                            onClick={() => {
                              setSelectedDownloadId(row.id);
                              setDownload(true);
                            }}
                          />
                        )}

                        {row.imperiality && haveDeletePermission && (
                          <FontAwesomeIcon
                            icon={faTrashCan}
                            onClick={() => {
                              setSelectedDeleteId(row.id); // store ID
                              setDelete(true); // open offcanvas
                            }}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ================= FOOTER ================= */}
        <div className="comon_page_footer">
          <div className="show_entry_div">
            <p className="show_text">
              Showing{" "}
              {(imperiality.current_page - 1) * imperiality.per_page + 1} To{" "}
              {Math.min(
                imperiality.current_page * imperiality.per_page,
                imperiality.total,
              )}{" "}
              Of {imperiality.total} Entries
            </p>
          </div>

          <div className="pagination_div">
            <Pagination_Holder
              onPageChange={imperiality.current_page}
              totalPages={imperiality.total_pages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>

      {showUploadModal && (
        <div className="modal common_modal fade show d-block" tabIndex="-1">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Upload Imperiality File</h5>
                  <button
                    className="btn-close"
                    onClick={handleCloseUploadModal}
                  />
                </div>

                <div className="modal-body">
                  <Form.Control
                    type="file"
                    {...register("image", {
                      required:
                        typeof getValues("image") === "string"
                          ? false
                          : "File is required",
                    })}
                    accept="*"
                  />
                  {errors.image && (
                    <small className="text-danger">
                      {errors.image.message}
                    </small>
                  )}

                  {(() => {
                    const fileValue = watch("image");

                    // URL for preview
                    const fileUrl =
                      typeof fileValue === "string"
                        ? process.env.REACT_APP_IMG_URL + fileValue
                        : fileValue?.length > 0
                        ? URL.createObjectURL(fileValue[0])
                        : null;

                    // Type detection
                    const fileType =
                      typeof fileValue === "string"
                        ? fileValue.toLowerCase()
                        : fileValue?.[0]?.type;

                    if (!fileUrl) return null;

                    return (
                      <div className="preview-container">
                        {/* IMAGE */}
                        {(fileType?.includes("image") ||
                          fileType?.endsWith(".jpg") ||
                          fileType?.endsWith(".jpeg") ||
                          fileType?.endsWith(".png")) && (
                          <img
                            src={fileUrl}
                            alt="Preview"
                            className="image-preview"
                            style={{ maxWidth: "100px" }}
                          />
                        )}

                        {/* PDF */}
                        {(fileType === "application/pdf" ||
                          fileType?.endsWith(".pdf")) && (
                          <iframe
                            src={fileUrl}
                            style={{ maxWidth: "100px" }}
                            title="PDF"
                          />
                        )}

                        {/* WORD */}
                        {(fileType?.includes("word") ||
                          fileType?.endsWith(".doc") ||
                          fileType?.endsWith(".docx")) && (
                          <div>
                            <p>Word preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Word File
                            </a>

                            <iframe
                              src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                              style={{ maxWidth: "100px" }}
                              title="Word Preview"
                            />
                          </div>
                        )}

                        {/* EXCEL */}
                        {(fileType?.includes("spreadsheet") ||
                          fileType?.endsWith(".xlsx") ||
                          fileType?.endsWith(".xls")) && (
                          <div>
                            <p>Excel preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Excel File
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={handleCloseUploadModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    // disabled={!selectedFile}
                    type="submit"
                    // onClick={handleUpload}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      )}

      {/* ================= OFFCANVAS ================= */}

      {haveReadPermission && (
        <Imperiality_view_offcanvas
          show={view}
          handleClose={() => setView(false)}
          id={viewId}
        />
      )}
      <Download_offcanvas
        show={showDownload}
        handleClose={() => setDownload(false)}
        offcanvasHeading="Download File"
        massageText="Imperiality"
        onConfirm={handleDownloadConfirm}
      />

      {haveDeletePermission && (
        <Delete_offcanvas
          show={showDelete}
          handleClose={() => setDelete(false)}
          handleDelete={handleDelete}
          offcanvasHeading="Delete File"
          massageText={"Impertiality"}
        />
      )}
    </>
  );
}

export default Imperiality_table;
